<div *ngIf="Isadd" class="example-container">
  <p class="title">New Products Configuration</p>
  <form [formGroup]="addProductsConfig">
    <arb-message class="message" [message$]="error$"></arb-message>
    <div>
      <div>
    <mat-form-field appearance="fill">
      <mat-label>Product Name</mat-label>
      <mat-select formControlName="productName">
        <mat-option [value]="product.id" *ngFor="let product of productsdata">
          {{product.name}}
        </mat-option>
    </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Duration</mat-label>
      <mat-select formControlName="duration"  >
        <mat-option value="Monthly">Monthly</mat-option>
        <mat-option value="Annually">Annually</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Plan Type</mat-label>
      <mat-select formControlName="plantype"  >
        <mat-option value="Upgrade">Upgrade</mat-option>
        <mat-option value="Onboard">Onboard</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field appearance="fill">
      <mat-label>Invite Limit</mat-label>
      <input matInput type="number"  formControlName="inviteslimit" placeholder="Limit">
    </mat-form-field>
  </div>
  </div>
    <br>
    <div class="actions">
      <button mat-raised-button color="primary" class="AddBtn" [disabled]="!addProductsConfig.valid" (click)="saveproductConfig()">Add</button>
      <button mat-flat-button class="close-button" mat-dialog-close (click)="close(false)">Close</button>
    </div>
  </form>
</div>
<div *ngIf="!Isadd" class="example-container">
  <p class="title">Edit Products Configuration Limit</p>
  <form [formGroup]="editProductsConfig">
    <arb-message class="message" [message$]="error$"></arb-message>
    <mat-form-field appearance="fill">
      <mat-label>Invite Limit</mat-label>
      <input matInput type="number"  formControlName="inviteslimitedit" placeholder="Limit">
    </mat-form-field>
    <br>
    <div class="actions">
      <button mat-raised-button color="primary" class="AddBtn" [disabled]="!editProductsConfig.valid" (click)="editProductsConfigLimit()">Save</button>
      <button mat-flat-button class="close-button" mat-dialog-close (click)="close(false)">Close</button>
    </div>
  </form>
</div>